import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import {
  QuestionBubbleHeader,
  QuestionBubbleLabel,
  NormalQuestionBubble,
} from "@/Shared/Components/QuestionBubble";

export function SavedCommoditiesSkuIdentifierQuestionBubble() {
  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>SKU Identifier</QuestionBubbleHeader>
          <QuestionBubbleLabel>
            <Stack gap={4}>
              <T>
                A SKU (Stock Keeping Unit) is a unique code you use to identify
                this product in your inventory system.
              </T>
              <T>
                Adding a SKU allows integrations like Shopify and BigCommerce to
                automatically match products to the correct commodity details
                when generating freight quotes.
              </T>
            </Stack>
          </QuestionBubbleLabel>
        </>
      }
    />
  );
}
